import { applyMiddleware, combineReducers, createStore, compose } from 'redux';

// import { createLogger } from 'redux-logger';
import layoutReducers from './layout/reducers.js';
import { reducer as oidcReducer } from 'redux-oidc';
import { redux } from 'ohif-core';
import { redux as apiRedux, ApiManager } from '../api';
import thunkMiddleware from 'redux-thunk';
import qs from 'query-string';

// Combine our ohif-core, ui, and oidc reducers
// Set init data, using values found in localStorage
const { reducers, localStorage } = redux;
// const loggerMiddleware = createLogger();

reducers.ui = layoutReducers;
reducers.oidc = oidcReducer;
reducers.api = apiRedux.reducers;

const rootReducer = combineReducers(reducers);

function loadLocalState() {
  const state = localStorage.loadState();
  const params = qs.parse(window.location.search);
  params.objects = params.objects ? JSON.parse(params.objects) : [];
  params.version = '1.0.0';
  return state;
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  loadLocalState(),
  composeEnhancers(
    applyMiddleware(
      thunkMiddleware // Lets us dispatch() functions
      // loggerMiddleware // neat middleware that logs actions
    )
  )
);

store.subscribe(() => {
  ApiManager.saveState({
    api: store.getState().api,
    preferences: store.getState().preferences,
  });
});

export default store;
export * from './layout/actions';
